import React from 'react'
import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/styles'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import useLanguage from 'app/components/selector/useLanguage'
import { IntlContext } from 'app/translations/intl-context'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  rootLink: {
    cursor: 'pointer',
    marginRight: theme.spacing(1),
  },
  dividerStyle: {
    width: '100%',
  },
  languageActive: {
    color: theme.palette.grey.main,
    marginRight: theme.spacing(1),
  },
}))

export default (props) => {
  const classes = useStyles()
  const { localizationLanguageSelected } = useLanguage()
  return (
    <IntlContext.Consumer>
      {({ locale, switchToLanguage }) => (
        <div className="flex justify-center">
          <div className="p-5 w-full text-center">
            <Divider className={clsx(classes.dividerStyle, 'mb-2')} />
            <Typography>
              {localizationLanguageSelected.map((item) =>
                locale === item.code ? (
                  <span
                    key={`languageCode${item.code}`}
                    className={classes.languageActive}
                  >
                    {item.name}
                  </span>
                ) : (
                  <Link
                    className={classes.rootLink}
                    onClick={() => switchToLanguage(item.code)}
                    key={`languageCode${item.code}`}
                  >
                    {item.name}
                  </Link>
                ),
              )}
            </Typography>
          </div>
        </div>
      )}
    </IntlContext.Consumer>
  )
}
